import logo from './logo.svg';
import './App.css';
import DriveGallery from "./DriveGallery";
import AppHeader from "./AppHeader";
import React, { useEffect } from 'react';

function App() {
  const queryParams = new URLSearchParams(window.location.search);
   const isEmbedded = queryParams.get("isEmbedded") === "true";

   useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      window.parent.postMessage(
        {
          type: "setHeight",
          height: document.documentElement.scrollHeight,
        },
        "*"
      );
    });
  
    resizeObserver.observe(document.body);
  
    return () => resizeObserver.disconnect();
  }, []);
  
  return (
    <div className="App">
     {!isEmbedded && <AppHeader />}
     
      <DriveGallery />  
    </div>
  );
}

export default App;
